import { client } from './client'
import type { LoginResult } from './auth'

export interface SetupStatus {
  needs_setup: boolean
}

export interface SetupAdminPayload {
  email: string
  password: string
  display_name?: string
}

export const setupApi = {
  status: async () => (await client.get('/setup/status')).data as SetupStatus,
  createAdmin: async (data: SetupAdminPayload) =>
    (await client.post('/setup/admin', data)).data as LoginResult,
}
